import { Component, Input, OnInit } from '@angular/core';
import { CourseStartDate } from '../../../models/pricelist-course-start-date.model';
import { getCourseStartDatesLabels } from '../../../utils/table-utils';
import { CompanyEnum } from '../../../models/company.model';
import { CourseStartDatesTableLabels } from '../../../models/types';
import { TableModule } from 'primeng/table';

@Component({
  standalone: true,
  imports: [TableModule],
  selector: 'lx-price-lists-portal-alp-course-start-dates',
  templateUrl: './alp-course-start-dates.component.html',
  styleUrls: ['./alp-course-start-dates.component.scss'],
})
export class AlpCourseStartDatesComponent implements OnInit {
  @Input() courseStartDates: CourseStartDate[] = [];

  columnLabels: CourseStartDatesTableLabels | undefined;

  ALP = CompanyEnum.ALP;

  ngOnInit(): void {
    this.columnLabels = getCourseStartDatesLabels(this.ALP);
  }
}
